<template>
    <span>{{ points }}</span>
</template>

<script>
import { PointsCategory, PointsPeriod, PointsCategoryPeriods } from '../../models';
import moment from 'moment';
import { ONLINE_QUEST_INDEXNAME } from '../../config/constants';

export default {
    props: {
        startDate: {},
        endDate: {},
        rhythmRepeat: {},
        isResponsible: {
            type: Boolean,
        },
        quest: {},
    },
    data() {
        return {
            loaded: false,
            pointsCategories: null,
            pointsPeriods: null,
            pointsCategoryPeriods: null,
        };
    },
    computed: {
        points() {
            let points = 0;
            if (this.quest && this.quest.activityType && (
                this.quest.activityType === ONLINE_QUEST_INDEXNAME ||
                this.quest.activityType.indexname === ONLINE_QUEST_INDEXNAME
            )) {
                if (this.quest.activityOnline) {
                    points = this.quest.activityOnline.points;
                }
            } else if (this.loaded && this.rhythmRepeat !== undefined && this.startDate && this.endDate) {
                if (this.rhythmRepeat === null && this.startDate && this.endDate) {
                    const daysWithHours = this.getDaysWithHours();
                    for (const dayWithHours of daysWithHours) {
                        const hours = dayWithHours.hours < 8 ? dayWithHours.hours : 8;
                        const day = dayWithHours.day;
                        points += this.getPointsByHoursAndDay(hours.toFixed(), day);
                    }
                } else {
                    let periodID;
                    let categoryID;
                    for (const period of this.pointsPeriods) {
                        if (period.name === 'Periodic') {
                            periodID = period.id;
                            break;
                        }
                    }
                    for (const category of this.pointsCategories) {
                        if (category.name === 'Periodic') {
                            categoryID = category.id;
                            break;
                        }
                    }
                    for (const pointsCategoryPeriod of this.pointsCategoryPeriods) {
                        if (
                            pointsCategoryPeriod.pointsPeriod.id === periodID &&
                            pointsCategoryPeriod.pointsCategory.id === categoryID &&
                            pointsCategoryPeriod.isForResponsible === this.isResponsible
                        ) {
                            points = pointsCategoryPeriod.points;
                            break;
                        }
                    }
                }
            }
            return points;
        },
    },
    methods: {
        getDaysWithHours() {
            const result = [];

            const startDate = moment(this.startDate);
            const endDate = moment(this.endDate);

            let day = 1;

            if (startDate.isSame(endDate, 'date')) {
                result.push({ day: day, hours: this.getHours(startDate, endDate, true) });
            } else {
                const endOfFirstDayDate = startDate.clone().set({
                    hours: 23,
                    minutes: 59,
                    seconds: 59,
                });
                result.push({ day: day, hours: this.getHours(startDate, endOfFirstDayDate, true) });

                startDate.add(1, 'day');
                startDate.set({
                    hour: 23,
                    minute: 59,
                    second: 59,
                });

                for (; endDate.isAfter(startDate); startDate.add(1, 'day')) {
                    if (day < 4) {
                        day++;
                    }
                    result.push({ day: day, hours: 8 });
                }

                if (day < 4) {
                    day++;
                }

                const startOfLastDayDate = endDate.clone().set({
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
                result.push({ day: day, hours: this.getHours(startOfLastDayDate, endDate) });
            }

            return result;
        },
        getHours(startDate, endDate, round) {
            const result = endDate.diff(startDate) / (1000 * 3600);

            if (round) {
                return parseFloat(result.toFixed(1));
            } else {
                return result;
            }
        },
        getPointsByHoursAndDay(hours, day) {
            let points = 0;
            let categoryHours;
            if (hours < 4) {
                categoryHours = 4;
            } else if (hours < 8) {
                categoryHours = 8;
            } else {
                categoryHours = 24;
            }

            let periodID;
            let categoryID;
            for (const period of this.pointsPeriods) {
                if (period.days === day) {
                    periodID = period.id;
                    break;
                }
            }
            for (const category of this.pointsCategories) {
                if (category.hours === categoryHours) {
                    categoryID = category.id;
                    break;
                }
            }
            for (const pointsCategoryPeriod of this.pointsCategoryPeriods) {
                if (
                    pointsCategoryPeriod.pointsPeriod.id === periodID &&
                    pointsCategoryPeriod.pointsCategory.id === categoryID &&
                    pointsCategoryPeriod.isForResponsible === this.isResponsible
                ) {
                    points = pointsCategoryPeriod.points;
                    break;
                }
            }
            return points;
        },
    },
    async beforeCreate() {
        const [
            pointsCategories,
            pointsPeriods,
            pointsCategoryPeriods,

        ] = await Promise.all(
            [
                PointsCategory.getData(),
                PointsPeriod.getData(),
                PointsCategoryPeriods.getData(),
            ]
        );
        this.pointsCategories = pointsCategories;
        this.pointsPeriods = pointsPeriods;
        this.pointsCategoryPeriods = pointsCategoryPeriods;
        this.loaded = true;
    },
};
</script>
